export const APP_VERSION = '0.4.0-m2c-dev';

export const API_BASE = (
  import.meta.env.VITE_API_BASE ?? 'http://127.0.0.1:4000'
).replace(/\/$/, '');

// Polling intervals (ms)
export const MANIFEST_SYNC_INTERVAL_MS = 30_000;
export const HEARTBEAT_INTERVAL_MS = 60_000;

// Playback defaults
export const DEFAULT_IMAGE_DURATION_MS = 8_000;
export const FADE_TRANSITION_MS = 500;

// Cache hydration concurrency cap
export const ASSET_FETCH_CONCURRENCY = 3;
